export const logger = (...data) => {
  console.log(...data);
};
